import { defineComponent as c, computed as m, openBlock as i, createElementBlock as t, normalizeClass as u, Fragment as o, createTextVNode as a, toDisplayString as n, createCommentVNode as r, createBlock as f, unref as k } from "vue";
import { ELinkBehaviors as h, ELinkSizes as v, ELinkIconPositions as b, ELinkVariants as y, ELinkVariantColors as _, getLinkStyleClasses as z } from "./novoui-vuejs59.js";
import "./novoui-vuejs71.js";
import "./novoui-vuejs72.js";
import "./novoui-vuejs3.js";
import "./novoui-vuejs4.js";
import "./novoui-vuejs5.js";
import "./novoui-vuejs6.js";
import "./novoui-vuejs7.js";
import "./novoui-vuejs79.js";
import "./novoui-vuejs80.js";
import "./novoui-vuejs9.js";
import C from "./novoui-vuejs10.js";
import "./novoui-vuejs41.js";
import "./novoui-vuejs12.js";
import "./novoui-vuejs13.js";
import "./novoui-vuejs14.js";
import "./novoui-vuejs15.js";
import "./novoui-vuejs16.js";
import "./novoui-vuejs18.js";
import "./novoui-vuejs20.js";
import "./novoui-vuejs21.js";
import "./novoui-vuejs22.js";
import "./novoui-vuejs23.js";
import "./novoui-vuejs25.js";
import "./novoui-vuejs26.js";
import "./novoui-vuejs27.js";
import "./novoui-vuejs28.js";
import "./novoui-vuejs29.js";
import "./novoui-vuejs30.js";
import "./novoui-vuejs31.js";
import "./novoui-vuejs32.js";
import "./novoui-vuejs33.js";
import "./novoui-vuejs36.js";
import "./novoui-vuejs110.js";
import "./novoui-vuejs39.js";
import "./novoui-vuejs40.js";
const L = ["href", "disabled"], me = /* @__PURE__ */ c({
  __name: "NLink",
  props: {
    behavior: { default: h.inline },
    label: { default: void 0 },
    size: { default: v.medium },
    disabled: { type: Boolean, default: !1 },
    icon: { default: void 0 },
    iconPosition: { default: b.left },
    variant: { default: y.default },
    variantColor: { default: _.default },
    underlined: { type: Boolean, default: !1 },
    href: { default: "javascript:void(0)" }
  },
  setup(p) {
    const e = p, s = m(() => z(e)), d = m(() => {
      switch (e.size) {
        case "tiny":
          return 12;
        case "small":
          return 14;
        case "medium":
        default:
          return 16;
      }
    });
    return (l, B) => (i(), t("a", {
      class: u(s.value),
      href: l.href,
      disabled: l.disabled
    }, [
      e.behavior === "inline" ? (i(), t(o, { key: 0 }, [
        a(n(e.label), 1)
      ], 64)) : e.behavior === "standalone" ? (i(), t(o, { key: 1 }, [
        e.iconPosition === "right" ? (i(), t(o, { key: 0 }, [
          a(n(e.label), 1)
        ], 64)) : r("", !0),
        e.icon ? (i(), f(k(C), {
          key: 1,
          icon: e.icon,
          size: d.value
        }, null, 8, ["icon", "size"])) : r("", !0),
        e.iconPosition === "left" ? (i(), t(o, { key: 2 }, [
          a(n(e.label), 1)
        ], 64)) : r("", !0)
      ], 64)) : r("", !0)
    ], 10, L));
  }
});
export {
  me as default
};
